// Import the functions you need from the SDKs you need
import { getAuth } from "firebase/auth";
// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

const firebaseConfig = {

    apiKey: "AIzaSyDETamIKmnblxZNjKn8mQeBsF4tqCwckzg",

    authDomain: "laptopbazar-326b3.firebaseapp.com",

    projectId: "laptopbazar-326b3",

    storageBucket: "laptopbazar-326b3.appspot.com",

    messagingSenderId: "835508694579",

    appId: "1:835508694579:web:e9ca79986375a435b9bd46"

};


// Initialize Firebase

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;